// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"TermsAndConditions-module--content-container--12JSg","textContainer":"TermsAndConditions-module--text-container--2LhSX"};